<template>
  <Root />
</template>

<script>
import Root from "./components/Root";
export default {
  components: { Root },
};
</script>

<style lang="scss">
body {
  margin: 0px;
  padding: 0px;
  font-family: sans-serif;
}
</style>
